"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Off24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 10V1H11V10H13ZM19.6895 4.28258L18.9721 3.58594L17.5788 5.02078L18.2962 5.71742L18.5163 5.93856C20.0994 7.58468 21 9.76164 21 12.0833C21 17.0065 16.9734 21 12 21C7.02848 21 3 17.0055 3 12.0833C3 9.66065 3.9913 7.39447 5.72153 5.71822L6.43975 5.02241L5.04812 3.58596L4.3299 4.28178L4.09007 4.52123C2.12492 6.54328 1 9.22486 1 12.0833C1 18.1139 5.92768 23 12 23C18.0742 23 23 18.1148 23 12.0833C23 9.10865 21.7921 6.32431 19.6895 4.28258Z", fill: "black" }));
}
function Off24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Off24Svg, Object.assign({}, svgProps)));
}
exports.default = Off24;
//# sourceMappingURL=Off24.js.map